import {PostData, Query} from '../../models/common';

export enum ActionTypes {
    SetErrorLoad = 'setErrorLoad',
    SetErrorShowMore = 'setErrorShowMore',
    SetIsShowMoreVisible = 'setIsShowMoreVisible',
    SetPosts = 'setPosts',
    SetShowMore = 'setShowMore',
    SetIsFetching = 'setIsFetching',
    PageChange = 'pageChange',
    QueryParamsChange = 'queryParamsChange',
}

export type State = {
    currentPage: number;
    errorLoad: boolean;
    errorShowMore: boolean;
    isFetching: boolean;
    isShowMoreVisible: boolean;
    lastLoadedCount: number;
    pinnedPostOnPage?: PostData;
    postCountOnPage: number;
    postsOnPage?: PostData[];
    queryParams: Query;
};

type Action =
    | {
          type: ActionTypes.PageChange;
          payload: number;
      }
    | {
          type: ActionTypes.SetIsFetching;
          payload: boolean;
      }
    | {
          type: ActionTypes.SetPosts;
          payload: {
              posts: PostData[];
              pinnedPost?: PostData;
              count: number;
              page: number;
          };
      }
    | {
          type: ActionTypes.SetShowMore;
          payload: {
              posts: PostData[];
              count: number;
              currentPage: number;
              lastLoadedCount: number;
          };
      }
    | {
          type: ActionTypes.SetErrorLoad;
          payload: boolean;
      }
    | {
          type: ActionTypes.SetErrorShowMore;
          payload: boolean;
      }
    | {
          type: ActionTypes.SetIsShowMoreVisible;
          payload: boolean;
      }
    | {
          type: ActionTypes.QueryParamsChange;
          payload: Query;
      };

export const reducer = (state: State, {type, payload}: Action): State => {
    switch (type) {
        case ActionTypes.SetIsShowMoreVisible:
            return {
                ...state,
                isShowMoreVisible: payload,
            };
        case ActionTypes.SetPosts:
            return {
                ...state,
                lastLoadedCount: payload.count,
                postCountOnPage: payload.count,
                pinnedPostOnPage: payload.pinnedPost,
                postsOnPage: payload.posts,
                currentPage: payload.page,
            };
        case ActionTypes.SetShowMore:
            return {
                ...state,
                lastLoadedCount: payload.lastLoadedCount,
                postCountOnPage: payload.count,
                currentPage: payload.currentPage,
                postsOnPage: payload.posts,
                errorShowMore: false,
            };
        case ActionTypes.SetIsFetching:
            return {
                ...state,
                isFetching: payload,
            };
        case ActionTypes.PageChange:
            return {
                ...state,
                currentPage: payload,
                isFetching: true,
            };
        case ActionTypes.SetErrorLoad:
            return {
                ...state,
                errorLoad: payload,
            };
        case ActionTypes.SetErrorShowMore:
            return {
                ...state,
                errorShowMore: payload,
            };

        case ActionTypes.QueryParamsChange:
            return {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    ...payload,
                },
            };
        default:
            return state;
    }
};
